import React from "react";
import membershipPlan from "../../common/assets/images/membershipPlan.svg";

const SelectMembership = () => {
  return (
    <div className="py-[100px] container flex gap-6 text-center">
      <div className="p-3" style={{ boxShadow: "1px 1px 11px 2px #0000002B" }}>
        <p className="darkBlue text-white py-6 text-3xl">LEVEL 1</p>
        <div className="flex items-center py-3">
          <div className="h-[1px] bg-[#051C34] w-1/2"></div>
          <p className="text-center text-[#051C34] text-3xl px-5">BASIC</p>
          <div className="h-[1px] bg-[#051C34] w-1/2"></div>
        </div>
        <img alt="" src={membershipPlan} className="mx-auto pb-2" />
        <button className="bg-[#C1F0FB] py-2 px-10">Select</button>
        <p className="py-7">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book.{" "}
        </p>
        <button
          className="py-2 px-4 mb-6"
          style={{ boxShadow: "1px 1px 3px 2px #00000030" }}
        >
          MemberShip Never Expires.
        </button>
      </div>
      <div className="p-3" style={{ boxShadow: "1px 1px 11px 2px #0000002B" }}>
        <p className="darkBlue text-white py-6 text-3xl">LEVEL 2</p>
        <div className="flex items-center py-3">
          <div className="h-[1px] bg-[#051C34] w-1/2"></div>
          <p className="text-center text-[#051C34] text-3xl px-5">PREMIUM</p>
          <div className="h-[1px] bg-[#051C34] w-1/2"></div>
        </div>
        <img alt="" src={membershipPlan} className="mx-auto pb-2" />
        <button className="bg-[#C1F0FB] py-2 px-10">Select</button>
        <p className="py-7">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book.{" "}
        </p>
        <button
          className="py-2 px-4 mb-6"
          style={{ boxShadow: "1px 1px 3px 2px #00000030" }}
        >
          MemberShip Never Expires.
        </button>
      </div>
    </div>
  );
};

export default SelectMembership;
